<template>
    <div>
        <!-- ======= Featured Services Section Section ======= -->
        <section id="featured-services">
            <div class="container">
                <div class="row">
                    <div class="box" style="height: 5em">
                    </div>
                </div>
            </div>
        </section><!-- End Featured Services Section -->
        <!-- ======= Portfolio Section ======= -->
        <section id="about" class="section-bg">
            <div class="container" data-aos="fade-up">
                <header class="section-header">
                    <h3 class="section-title">Mettez ici vos idées ou demandes, nous vous contacterons dans les plus brefs délais</h3>
                </header>
                <div class="row" data-aos="fade-up" data-aos-delay="200">
                    <mdb-jumbotron class="ide">
                        <form method="post" role="form" class="php-email-form">
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <input type="text" name="name"
                                           class="form-control"
                                           v-model="formMessage.name"
                                           placeholder="Votre nom"/>
                                    <div class="validate"></div>
                                </div>
                                <div class="form-group col-md-6">
                                    <input type="text" name="name"
                                           class="form-control"
                                           v-model="formMessage.contact"
                                           placeholder="Votre contact"/>
                                    <div class="validate"></div>
                                </div>
                            </div>
<!--                            <div class="form-group">-->
<!--                                <textarea class="form-control"-->
<!--                                          v-model="formMessage.message"-->
<!--                                          rows="5"-->
<!--                                          data-rule="required"-->
<!--                                          data-msg="Votre message"-->
<!--                                          placeholder="Votre message"></textarea>-->
<!--                                <div class="validate"></div>-->
<!--                            </div>-->
                            <div class="form-group" id="editorContainer">
                                <Vueditor ref="editorContainer"></Vueditor>
                            </div>
                            <div class="text-center">
                                <mdb-btn outline="success"
                                         v-loading.fullscreen.lock="loading"
                                         @click="send">Envoyer
                                </mdb-btn>
                            </div>
                        </form>
                    </mdb-jumbotron>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { mdbBtn, mdbJumbotron } from 'mdbvue';
    import {mapActions} from "vuex";
    import {required} from "vuelidate/lib/validators";
    export default {
        name: "index",
        components:{
            mdbBtn,
            mdbJumbotron
        },
        validations:{
            formMessage:{
                name: {
                    required
                },
                contact: {
                    required
                }
            }
        },
        data(){
            return {
                formMessage: {},
                loading: false
            }
        },
        methods:{
            ...mapActions('user',['sendMessageAction']),
            async send(){
                const h = this.$createElement;
                let editor = this.$refs.editorContainer
                this.formMessage.message = editor.getContent()
                this.$v.$touch()
                if (this.$v.$invalid || this.formMessage.message == '') {
                    this.$notify.warning({
                        title: 'Email',
                        message: h('i', { style: 'color: teal' }, 'Les champs sont obligatoires'),
                        duration: 2000
                    });
                    return
                }

                this.loading = true
                await this.sendMessageAction(this.formMessage)
                this.loading = false

                this.$notify.success({
                    title: 'Message',
                    message: h('i', { style: 'color: teal' }, 'Message envoyé'),
                    duration: 2000
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ide {
        width: 70%;
        margin: 0 auto;
        @media (max-width:455px) {
            width: 95%;
        }
    }
    .vueditor {
        min-height: 300px;
    }
    
</style>